import gestionDateBase from '@/services/general/gestionDateBase';

export default function initialize(tiers) {
  tiers.dateSignatureMandatSepa = gestionDateBase(tiers.dateSignatureMandatSepa);
  tiers.dateNaissance = gestionDateBase(tiers.dateNaissance);
  tiers.dateAnniversaireContrat = gestionDateBase(tiers.dateAnniversaireContrat);
}
